import { checkUserIsConnectedOnStart } from '@/domain/auth/actions/check-user-connected-on-start.action';
import { getUserInfos } from '@/domain/auth/actions/get-user-infos.action';
import { selectIsAuthenticated } from '@/domain/auth/auth.selectors';
import { store } from '@/domain/store';

/**
 * Make technical actions to check if user is connected
 * - check local-storage : accessToken is present?
 * - if yes, make usersInfos api call to validate that the token is valid (not expired)
 * @returns user is connected or not
 */
export async function prepareAuth(
  {
    validateTokenByApiCall,
  }: {
    validateTokenByApiCall: boolean;
  } = { validateTokenByApiCall: true },
) {
  try {
    await store.dispatch(checkUserIsConnectedOnStart()).unwrap();
    const isAuthenticated = selectIsAuthenticated(store.getState());
    if (!isAuthenticated) {
      return { userIsConnected: false };
    }
    if (validateTokenByApiCall) {
      await store.dispatch(getUserInfos()).unwrap();
    }
    return { userIsConnected: true };
  } catch (error) {
    console.error(error);
  }
  return { userIsConnected: false };
}
